// extracted by mini-css-extract-plugin
export default {"gameTitlesWrap":"styles_gameTitlesWrap__4gppV","gamesTitles":"styles_gamesTitles__dN1s+","gamesTitlesCurrent":"styles_gamesTitlesCurrent__nRGsB"};